import { array, object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';
import { checkMinMaxObjectKeyValues } from 'common/utils/helpers';

import { buildFields } from '../base/builders/buildValidationFields';

export default () => {
    const { getMaxValueText, getMinValueText, REQUIRED_TEXT } =
        getValidationTexts();
    const {
        name,
        opex,
        opex_cost_ranges_kw,
        opex_costing_type,
        parameters,
        parameters_commission_credit,
        parameters_hitch,
        parameters_rate,
    } = buildFields();

    return object().shape({
        api_key: string().when('type_algorithm', {
            is: 'ppa_api_key',
            then: () => string().required(REQUIRED_TEXT),
            otherwise: () => string().nullable(),
        }),
        name,
        opex,
        opex_cost_ranges_kw,
        opex_costing_type,
        parameters: object().shape({
            tax: parameters.tax,
            terms: array()
                .test(
                    'terms-range',
                    getMaxValueText('30') + ', ' + getMinValueText('1'),
                    (value) => checkMinMaxObjectKeyValues(value, 1, 30),
                )
                .nullable(),
        }),
        parameters_commission_credit,
        parameters_hitch,
        parameters_rate,
    });
};
